import { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFetch from "hooks/useFetch";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Question.scss";

const Question = ({
  question,
  questionsQuantity,
  ids,
  questionIndex,
  handleClose,
}) => {
  const { post } = useFetch();
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [answered, setAnswered] = useState();
  const [questionsAnsweredCorrectly, setQuestionsAnsweredCorrectly] = useState(
    []
  );
  const currentUser = useSelector((state) => state.auth.currentUser);
  const type = question && question.is_multiple ? "checkbox" : "radio";
  const correctAnswers =
    question && question.answers.filter((answer) => answer.is_correct);
  const { t } = useTranslation("lesson");

  const handleChangeCheckbox = (event) => {
    if (event.target.checked) {
      setSelectedAnswers([...selectedAnswers, Number(event.target.value)]);
    } else {
      setSelectedAnswers(
        selectedAnswers.filter(
          (answer) => answer !== Number(event.target.value)
        )
      );
    }
  };

  const handleChangeRadio = (event) => {
    setSelectedAnswers([Number(event.target.value)]);
  };

  const handleValidation = (event) => {
    event.preventDefault();
    const correctAnswersIds = correctAnswers.map((answer) => answer.id);

    if (
      JSON.stringify(selectedAnswers.sort()) ===
      JSON.stringify(correctAnswersIds.sort())
    ) {
      setAnswered("right");
      setQuestionsAnsweredCorrectly([
        ...questionsAnsweredCorrectly,
        question.id,
      ]);
    } else {
      setAnswered("wrong");
    }
  };

  useEffect(() => {
    sendResult();
  }, [questionsAnsweredCorrectly]);

  const sendResult = () => {
    const score = `${questionsAnsweredCorrectly.length}/${questionsQuantity}`;
    post(
      `/courses/${ids.course}/chapters/${ids.chapter}/lessons/${ids.lesson}/results`,
      { quizz_result: score }
    );
  };

  useEffect(() => {
    setSelectedAnswers([]);
    setAnswered();
  }, [question]);

  return (
    <div className="Question h-100 d-flex justify-content-center flex-column">
      <h3 className="mt-3 mb-5">{question.content} ?</h3>

      <Form>
        <div key={`default-${type}`} className="mb-3">
          {question.answers.map((answer) => (
            <Form.Check
              className="mb-2"
              key={answer.id}
              type={type}
              name={type}
              label={answer.content}
              onChange={
                type === "radio" ? handleChangeRadio : handleChangeCheckbox
              }
              value={answer.id}
              required
            />
          ))}
        </div>
        {!answered && (
          <div className="row justify-content-center">
            <Button
              onClick={handleValidation}
              is_disabled={selectedAnswers.length < 1}
              className="modal-question-validation-button"
            >
              {t("validate_response")}
            </Button>
          </div>
        )}
        {(answered === "right" && (
          <div className="d-flex flex-column align-items-center">
            <hr className="w-50" />
            <p className="answer-status">{t("congratulations")} !</p>
            <p className="answer-explanation">{question.explanation}</p>
          </div>
        )) ||
          (answered === "wrong" && (
            <>
              <div className="d-flex flex-column align-items-center">
                <hr className="w-50" />
                <p className="answer-status">{t("too_bad")} !</p>
                <p className="answer-explanation">{question.explanation}</p>
              </div>
              <p className="d-flex justify-content-center">
                {(question.is_multiple &&
                  t("correct_answers_were") +
                    correctAnswers.map((answer) => ` ${answer.content}`)) ||
                  t("correct_answer_was") + " " + correctAnswers[0].content}
              </p>
            </>
          ))}
        {answered && questionIndex === questionsQuantity - 1 && (
          <div className="d-flex flex-column align-items-end mt-5">
            <p>
              {t("quizz_over")} ! {t("result")}:{" "}
              {questionsAnsweredCorrectly.length + " / " + questionsQuantity}
            </p>{" "}
            {(question.lesson.next_lesson && (
              <Link
                onClick={handleClose}
                to={`/courses/${ids.course}/chapters/${question.lesson.next_lesson.chapter_id}/lessons/${question.lesson.next_lesson.id}`}
                className="next-lesson-button"
              >
                {t("go_to_next_lesson")}
              </Link>
            )) || (
              <div className="d-flex flex-column justify-content-center">
                <h5>{t("course_is_over")}</h5>
                <Link className="go-back-profile" to={"/profile/mycourses"}>
                  {t("back_to_profile")}
                </Link>
              </div>
            )}
          </div>
        )}
      </Form>
    </div>
  );
};

export default Question;
